import React, { Fragment, useLayoutEffect, useState } from "react";
import CustomersListComponent from "../component/app/insurance/CustomersList.component";
import BreadcrumbsComponent from "../component/base/Breadcrumbs.component";
import { Box } from "@mui/material";

const InsurancePage = () => {
  const [breadcrumb, setBreadcrumb] = useState({
    title: "",
    links: [
      { path: "/", name: "Home" },
      { path: null, name: "Insurance" },
    ],
  });

  useLayoutEffect(() => {
    setBreadcrumb({
      ...breadcrumb,
      title: `Customers`,
    });
  }, []);

  return (
    <Fragment>
      {/* <Box display={"flex"}> */}
        <BreadcrumbsComponent {...breadcrumb} />
      {/* </Box> */}

      <CustomersListComponent />
    </Fragment>
  );
};

export default InsurancePage;
